import React, { useState, useEffect, useContext } from "react";
import { Route } from "react-router-dom";
import Form from "./components/form";
import ViewForms from "./view";
import { getPortalSurveys } from "../../../../api";
import styled from "styled-components";
import { AuthContext } from "../../../../auth-context.js";

// const sampleResponses = {
//   id: 49,
//   survey_id: 1,
//   report_date: "2025-02-01",
//   response_data: [
//     {
//       question_id: "72e15ad6-6048-46c0-837f-3a6c2deeb9b2",
//       response: ["80b0239f-cde5-4862-b8f2-bc9f2f62bf4f"],
//     },
//     {
//       question_id: "e422246d-1df2-4455-9714-371ba8482e2e",
//       response: "No",
//     },
//     {
//       question_id: "f29bc31d-cd55-4f34-9740-8c874efe36fa",
//       response: "To lose weight sustainably",
//     },
//     {
//       question_id: "8705c164-5d78-41d9-9508-69fbede8e337",
//       response: "No",
//     },
//     {
//       question_id: "9846a6c7-41bf-4b4f-a7e5-b3288963160d",
//       response: [
//         "1b7f2642-4b2e-423f-b70f-ee27ae5af3d0",
//         "9846a6c7-41bf-4b4f-a7e5-b3288963160d",
//       ],
//     },
//     {
//       question_id: "663395bc-f2b7-46e9-813e-600e0eaa6f07",
//       response: ["258d31e3-7e33-4c18-a9d0-c0b0e05dfdd5"],
//     },
//   ],
// };

// const sampleLoadedForms = [
//   {
//     id: 1,
//     name: "Detailed Example Form for Clients under 50",
//     createdAt: "2025-02-01",
//     updatedAt: "2025-02-06",
//     survey_data: {
//       title: "Monthly Wellness Check for February 2025",
//       description:
//         "This comprehensive wellness check helps us understand your current fitness level and any health concerns you may have. The information collected allows us to provide personalized recommendations and track your progress over time. Please answer each question thoughtfully to help us serve you better.",
//       questions: [
//         {
//           id: "72e15ad6-6048-46c0-837f-3a6c2deeb9b2",
//           title: "How often do you exercise?",
//           description:
//             "Please select the option that best describes your exercise frequency",
//           responseType: "multiple_choice",
//           required: true,
//           options: [
//             {
//               id: "c4ff8f0f-ebdf-4c4f-b904-bcd99e7673f4",
//               value: "Never",
//             },
//             {
//               id: "80b0239f-cde5-4862-b8f2-bc9f2f62bf4f",
//               value: "1-2 times per week",
//             },
//             {
//               id: "9c421b33-2951-4015-bfcf-4788fae44836",
//               value: "3-4 times per week",
//             },
//             {
//               id: "9dd4853d-83ea-44c8-b49f-54b920dc1c21",
//               value: "5+ times per week",
//             },
//           ],
//         },
//         {
//           id: "e422246d-1df2-4455-9714-371ba8482e2e",
//           title: "Do you have any injuries or medical conditions?",
//           description: "This helps us customize your program safely",
//           responseType: "text",
//           required: false,
//         },
//         {
//           id: "f29bc31d-cd55-4f34-9740-8c874efe36fa",
//           title: "What are your fitness goals?",
//           responseType: "text",
//           required: false,
//         },
//         {
//           id: "8705c164-5d78-41d9-9508-69fbede8e337",
//           title: "Did you encounter any issues with your last workout?",
//           responseType: "text",
//           required: false,
//         },
//         {
//           id: "b0852ce1-64d2-49c7-b836-86c3610b0eda",
//           title: "Did experience any of the following issues this week?",
//           responseType: "checkbox",
//           required: false,
//           options: [
//             {
//               id: "1b7f2642-4b2e-423f-b70f-ee27ae5af3d0",
//               value: "Pain",
//             },
//             {
//               id: "9846a6c7-41bf-4b4f-a7e5-b3288963160d",
//               value: "Fatigue",
//             },
//             {
//               id: "a7aebe38-7743-4626-b82a-489429f3615f",
//               value: "Nausea",
//             },
//             {
//               id: "7ed283b3-387f-419b-bff3-b474f1e6c7c4",
//               value: "Dizziness",
//             },
//             {
//               id: "7aed584e-d711-4f1c-b0d4-ca51b5132d90",
//               value: "None",
//             },
//           ],
//         },
//         {
//           id: "663395bc-f2b7-46e9-813e-600e0eaa6f07",
//           title: "Do you have any of the following health concerns?",
//           responseType: "checkbox",
//           required: true,
//           options: [
//             {
//               id: "258d31e3-7e33-4c18-a9d0-c0b0e05dfdd5",
//               value: "High blood pressure",
//             },
//             {
//               id: "e5e18cc4-e297-441d-af69-0f00b98ea4a9",
//               value: "High cholesterol",
//             },
//             {
//               id: "5ecdf302-5f13-42e2-907a-419236bc7063",
//               value: "Diabetes",
//             },
//             {
//               id: "2d6310bd-02a9-4500-986c-3f7c1e52f4ee",
//               value: "Heart disease",
//             },
//             {
//               id: "32951e88-c521-4490-a548-3f726a8efd98",
//               value: "Depression",
//             },
//             {
//               id: "8cb2d2ac-8613-4fbb-8fcd-b819c543cb8b",
//               value: "Anxiety",
//             },
//             {
//               id: "d3331136-a601-46f9-bed0-84130f89d738",
//               value: "Asthma",
//             },
//             {
//               id: "c17a1819-e697-4d90-b120-4ed2907e4b96",
//               value: "Arthritis",
//             },
//             {
//               id: "d76a516d-4c36-40be-832d-79f558042afa",
//               value: "Osteoporosis",
//             },
//             {
//               id: "045a51ef-3f5e-425a-8b79-b8e8f9591a39",
//               value: "Chronic pain",
//             },
//             {
//               id: "3c95726d-4248-432f-8a46-9cc1620ca545",
//               value: "Sleep apnea",
//             },
//             {
//               id: "46bd39ee-37f4-4246-afbb-fa54cdf76698",
//               value: "Thyroid condition",
//             },
//             {
//               id: "9aa78748-d0ef-462a-9ff2-509b2e3e8db0",
//               value: "Autoimmune disorder",
//             },
//             {
//               id: "31d950ad-8a09-48e1-8ffb-946a1260a43f",
//               value: "Chronic fatigue",
//             },
//             {
//               id: "829cbfb1-bd53-4c23-addc-3007e8e5107f",
//               value: "Fibromyalgia",
//             },
//             {
//               id: "077265fd-9fef-424a-82bd-cc6cd516597b",
//               value: "None of the above",
//             },
//           ],
//         },
//       ],
//     },
//   },
//   {
//     id: 2,
//     name: "Nutrition Assessment Form for 2025",
//     title: "Describing eating habits",
//     description: "Evaluate your current eating habits",
//     createdAt: "2025-05-02",
//     updatedAt: "2025-05-07",
//     questions: [
//       {
//         id: 1,
//         title: "How many meals do you eat per day?",
//         description: "Include snacks in your count",
//         responseType: "multiple_choice",
//         required: true,
//         options: [
//           { id: 1, value: "1-2 meals" },
//           { id: 2, value: "3-4 meals" },
//           { id: 3, value: "5+ meals" },
//         ],
//       },
//       {
//         id: 2,
//         title: "Do you track your calories?",
//         responseType: "multiple_choice",
//         required: true,
//         options: [
//           { id: 1, value: "Yes" },
//           { id: 2, value: "No" },
//         ],
//       },
//     ],
//   },
//   {
//     id: 4,
//     name: "Lifestyle Survey (in progress example)",
//     title: "Understanding your daily routine",
//     description: "Understanding your daily routine",
//     createdAt: "2025-05-04",
//     updatedAt: "2025-05-09",
//     questions: [
//       {
//         id: 1,
//         title: "What time do you typically wake up?",
//         responseType: "text",
//         required: true,
//       },
//       {
//         id: 2,
//         title: "How many hours do you sleep per night?",
//         responseType: "multiple_choice",
//         required: true,
//         options: [
//           { id: 1, value: "Less than 6 hours" },
//           { id: 2, value: "6-7 hours" },
//           { id: 3, value: "7-8 hours" },
//           { id: 4, value: "8+ hours" },
//         ],
//       },
//     ],
//   },
//   {
//     id: 5,
//     name: "Linear Scale Form",
//     title: "Linear Scale Form",
//     description: "Linear Scale Form",
//     createdAt: "2025-05-05",
//     min: 1,
//     max: 10,
//   },
// ];

// console.log('response data: ', JSON.stringify(sampleResponses.response_data))
// console.log('survey data: ', JSON.stringify(sampleLoadedForms[0].survey_data))

const Container = styled.div`
  padding: 32px 16px 200px 16px;
  margin: 0 auto;
  max-width: 1440px;
`;

const Forms = (props) => {
  const { user } = useContext(AuthContext);
  const [formsState, setFormsState] = useState(0);
  const [forms, setForms] = useState([]);

  const fetchSurveys = () => {
    setFormsState(1);
    return getPortalSurveys(user.id).then((res) => {
      setForms(res.data?.surveys);
      setFormsState(2);
    });
  };

  useEffect(() => {
    if (formsState === 0 && user.id) {
      fetchSurveys();
    }
  }, [formsState, user.id]);

  return (  
    <Container>
      <Route path="/dashboard/forms/view">
        <ViewForms history={props.history} forms={forms} setForms={setForms} fetchSurveys={fetchSurveys}/>
      </Route>
      <Route path="/dashboard/forms/create">
        <Form create fetchSurveys={fetchSurveys} />
      </Route>
      <Route path="/dashboard/forms/edit/:id">
        <Form forms={forms} fetchSurveys={fetchSurveys} />
      </Route>
    </Container>
  );
};

export default Forms;
